module.exports = __webpack_public_path__ + "img/google-dv360.df155423.png";